import { useContext } from 'react';
import { SettingsContext } from 'src/PWM/context/settings-context';

export const useSettings = () => useContext(SettingsContext);
